import styled, { css } from 'styled-components';
import { rem, rgba, cssVar } from 'polished';
import { prefix } from '../../tools/settings';
import SearchInput from '../SearchInput';
import Divider from '../Divider';
var List2 = styled.div.withConfig({
  displayName: "List2styles__List2",
  componentId: "sc-ooc1xt-0"
})(["display:flex;flex-flow:column nowrap;flex:1 1 auto;"]);
var List2Head = styled.div.attrs({
  className: 'dentsu-list2__head'
}).withConfig({
  displayName: "List2styles__List2Head",
  componentId: "sc-ooc1xt-1"
})(["width:100%;display:", ";align-items:center;height:68px;font-size:14px;color:var(--dentsu-color-n700);padding:0 24px;top:0;background:inherit;z-index:1;border-bottom:1px solid var(--dentsu-color-n300);&:empty{display:none;}"], function (props) {
  return props.shouldHideHeader ? 'none' : 'flex';
});
var List2SearchContainer = styled.div.withConfig({
  displayName: "List2styles__List2SearchContainer",
  componentId: "sc-ooc1xt-2"
})(["display:flex;align-items:center;justify-content:space-between;flex:1;font-size:14px;"]);
var List2HeadAction = styled.div.withConfig({
  displayName: "List2styles__List2HeadAction",
  componentId: "sc-ooc1xt-3"
})([".dentsu-button{height:36px;padding-top:11px;padding-bottom:11px;padding-left:20px;padding-right:20px;}"]);
var List2HeadCell = styled.div.withConfig({
  displayName: "List2styles__List2HeadCell",
  componentId: "sc-ooc1xt-4"
})(["display:flex;flex-flow:row nowrap;", ""], function (props) {
  return props.right && css(["> *{margin-left:12px;}> .", "-segmented-control{margin-left:6px;}"], prefix);
});
var List2FilterButton = styled.button.withConfig({
  displayName: "List2styles__List2FilterButton",
  componentId: "sc-ooc1xt-5"
})(["outline:none;position:relative;padding:0 16px;margin-left:8px;align-items:center;display:inline-flex;border-radius:18px;height:36px;font-size:14px;cursor:pointer;color:var(--dentsu-color-black);background-color:var(--dentsu-color-white);border:1px solid var(--dentsu-color-n300);transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);transition-property:box-shadow;&:focus{box-shadow:0 0 0 ", " ", ";}"], rem(4), rgba(cssVar('--dentsu-color-p150', '#cebaed'), 0.6));
var List2HeadSeparator = styled(Divider).attrs({
  orientation: 'vertical',
  isFlexChild: true
}).withConfig({
  displayName: "List2styles__List2HeadSeparator",
  componentId: "sc-ooc1xt-6"
})(["margin-top:20px;margin-left:12px;margin-right:12px;margin-bottom:20px;"]);
var List2Body = styled.div.withConfig({
  displayName: "List2styles__List2Body",
  componentId: "sc-ooc1xt-7"
})(["width:100%;position:relative;z-index:0;"]);
var List2Row = styled.div.withConfig({
  displayName: "List2styles__List2Row",
  componentId: "sc-ooc1xt-8"
})(["display:flex;width:100%;padding:0 12px;flex-flow:row nowrap;background:var(--dentsu-color-white);border-bottom:1px solid var(--dentsu-color-n300);", ""], function (props) {
  return props.onClick && css(["cursor:pointer;box-shadow:none;transition:box-shadow var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);&:hover{box-shadow:var(--dentsu-shadow-2);}&:active{box-shadow:none;}"]);
});
var List2Cell = styled.div.withConfig({
  displayName: "List2styles__List2Cell",
  componentId: "sc-ooc1xt-9"
})(["display:flex;flex-flow:column nowrap;flex-grow:1;flex-basis:0;position:relative;justify-content:center;line-height:1;padding:16px 12px;", " ", " ", ""], function (props) {
  return props.image && css(["max-width:64px;"]);
}, function (props) {
  return props.title && css(["padding-right:20px;"]);
}, function (props) {
  return props.actions && css(["justify-content:flex-end;flex-flow:row nowrap;align-items:center;flex-grow:0;flex-shrink:1;> *{margin-left:8px;}"]);
});
var List2Title = styled.h3.withConfig({
  displayName: "List2styles__List2Title",
  componentId: "sc-ooc1xt-10"
})(["color:var(--dentsu-color-black);font-weight:var(--dentsu-font-weight-medium);font-size:var(--dentsu-font-size-14);line-height:", ";max-width:360px;"], rem(20));
var List2Caption = styled.p.withConfig({
  displayName: "List2styles__List2Caption",
  componentId: "sc-ooc1xt-11"
})(["color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:", ";max-width:360px;"], rem(20));
var List2Search = styled(SearchInput).withConfig({
  displayName: "List2styles__List2Search",
  componentId: "sc-ooc1xt-12"
})(["width:auto;.bp3-input{width:120px;transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:focus,&:not(:placeholder-shown){width:210px;text-overflow:initial;}}"]);
var List2Pagination = styled.div.withConfig({
  displayName: "List2styles__List2Pagination",
  componentId: "sc-ooc1xt-13"
})(["height:68px;display:flex;justify-content:space-between;align-items:center;font-size:14px;color:var(--dentsu-color-n700);padding:16px 16px;"]);
var List2PaginationSelection = styled.span.withConfig({
  displayName: "List2styles__List2PaginationSelection",
  componentId: "sc-ooc1xt-14"
})(["&::first-letter{text-transform:capitalize;}"]);
var List2PaginationOptions = styled.div.withConfig({
  displayName: "List2styles__List2PaginationOptions",
  componentId: "sc-ooc1xt-15"
})([""]);
var List2PaginationNavigation = styled.div.withConfig({
  displayName: "List2styles__List2PaginationNavigation",
  componentId: "sc-ooc1xt-16"
})([""]);
var List2PaginationButtons = styled.span.withConfig({
  displayName: "List2styles__List2PaginationButtons",
  componentId: "sc-ooc1xt-17"
})(["border-left:1px solid var(--dentsu-color-n300);margin-left:16px;padding-left:8px;"]);
var List2Action = styled.div.withConfig({
  displayName: "List2styles__List2Action",
  componentId: "sc-ooc1xt-18"
})([".dentsu-button{height:36px;padding-top:11px;padding-bottom:11px;padding-left:20px;padding-right:20px;}"]);
var List2Filters = styled.div.withConfig({
  displayName: "List2styles__List2Filters",
  componentId: "sc-ooc1xt-19"
})(["&:empty{display:none;}"]);
export var Styled = {
  List2: List2,
  List2Head: List2Head,
  List2HeadCell: List2HeadCell,
  List2Body: List2Body,
  List2Row: List2Row,
  List2Cell: List2Cell,
  List2Title: List2Title,
  List2Caption: List2Caption,
  List2Pagination: List2Pagination,
  List2PaginationSelection: List2PaginationSelection,
  List2PaginationOptions: List2PaginationOptions,
  List2PaginationNavigation: List2PaginationNavigation,
  List2PaginationButtons: List2PaginationButtons,
  List2Action: List2Action,
  List2SearchContainer: List2SearchContainer,
  List2Search: List2Search,
  List2HeadAction: List2HeadAction,
  List2HeadSeparator: List2HeadSeparator,
  List2Filters: List2Filters,
  List2FilterButton: List2FilterButton
};